import moment from 'moment'

const toProperCase = (v: unknown): string =>
  String(v ?? '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase())

const formatDate = (v: unknown): string =>
  v ? moment(String(v)).format('MMM D, YYYY') : 'TBD'

export interface HistoryFieldConfig {
  title: string
  badge: string
  format: (v: unknown) => string
}

// Config for the fields surfaced in the first step of Property History.
export const HISTORY_FIELD_CONFIG: Record<string, HistoryFieldConfig> = {
  'auction/start_date': {
    title: 'Sale Date Updated',
    badge: 'Date Updated',
    format: formatDate,
  },
  'listing_configuration/occupancy_status': {
    title: 'Occupancy Updated',
    badge: 'Occupancy',
    format: toProperCase,
  },
}

export const getFieldConfig = (field: string): HistoryFieldConfig | null =>
  HISTORY_FIELD_CONFIG[field] || null

export const formatTimestamp = (changedAt: string | number | Date): string =>
  moment(changedAt).format('MMMM D, h:mm A')
